import { createAction, createActionWithPayload } from 'utils/redux';

import { CLEAR, RECEIVE } from './constants';
import { ProductRFPs } from './types';

export const receiveRFPs = createActionWithPayload<ProductRFPs>(RECEIVE);
export const clearRFPs = createAction(CLEAR);
